import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { companyInfo } from '../data/mock';

const MessengerWidget = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    // Show widget after 2 seconds
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const handleMessengerClick = () => {
    window.open(companyInfo.messenger, '_blank');
  };

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-40">
      {/* Expanded tooltip */}
      {isExpanded && (
        <div className="absolute bottom-20 right-0 bg-slate-900 border border-slate-700 rounded-xl p-4 shadow-2xl w-72 animate-in slide-in-from-bottom-2 hidden sm:block">
          <button
            onClick={toggleExpanded}
            className="absolute top-2 right-2 p-1 hover:bg-slate-800 rounded-lg transition-colors"
          >
            <X className="text-gray-400" size={16} />
          </button>
          <div className="pr-6">
            <h3 className="text-white font-semibold mb-2 flex items-center">
              <MessageCircle className="text-blue-500 mr-2" size={20} />
              Chat with HVGTEC
            </h3>
            <p className="text-gray-400 text-sm mb-4">
              Have questions about our FTTH plans? Our team is ready to help you via Messenger!
            </p>
            <button
              onClick={handleMessengerClick}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-lg transition-all duration-200 flex items-center justify-center"
            >
              <MessageCircle className="mr-2" size={18} />
              Open Messenger
            </button>
          </div>
        </div>
      )}

      {/* Floating button - optimized for mobile */}
      <button
        onClick={isExpanded ? toggleExpanded : handleMessengerClick}
        onMouseEnter={() => !isExpanded && window.innerWidth >= 640 && setIsExpanded(true)}
        className="group relative bg-blue-600 hover:bg-blue-700 text-white w-14 h-14 sm:w-16 sm:h-16 rounded-full shadow-2xl transition-all duration-300 hover:scale-110 flex items-center justify-center"
      >
        <MessageCircle size={24} className="sm:block hidden" />
        <MessageCircle size={20} className="sm:hidden block" />
        
        {/* Pulse animation */}
        <span className="absolute inset-0 rounded-full bg-blue-600 animate-ping opacity-20"></span>
        
        {/* Badge for "Live" */}
        <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold px-1.5 py-0.5 sm:px-2 sm:py-0.5 rounded-full">
          Live
        </span>
      </button>
    </div>
  );
};

export default MessengerWidget;
